module.exports = function () {
  var html = "<div class=\"rules-overlay\">\n    <h1>Here I Stand</h1>\n    <p>This overlay is under development.</p>\n    </div>";
  return html;
};